import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyFailed } from './components/WhyFailed';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForWhom } from './components/ForWhom';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#050505] text-white font-sans selection:bg-brand-green selection:text-black" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <OpeningHook data-id="element-4" />
        <Problem data-id="element-5" />
        <WhyFailed data-id="element-6" />
        <Mechanism data-id="element-7" />
        <WhatYouGet data-id="element-8" />
        <ForWhom data-id="element-9" />
        <HowItWorks data-id="element-10" />
        <Proof data-id="element-11" />
        <FAQ data-id="element-12" />
        <Offer data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}